import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  root: {
    width: '100%',
    height: '80vh',
    border: '1px solid #aaa',
    overflowY: 'hidden',
    overflowX: 'scroll',
    borderRadius: '1vh',
  },
  floatLeft: {
    float: 'left',
    borderLeft: '1px solid #aaa',
    height: '100%',
  },
  coulomContent: {
    width: 'auto',
  },
  header: {
    padding: '0 1.75vh',
    width: '100%',
    height: '72.5px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontSize: '15px',
    color: 'white',
    textTransform: 'uppercase',
  },
  content: {
    width: '100%',
    height: '45.5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Poppins',
    fontSize: '15px',
    color: '#0E1247',
  },
});
